/**
 * Convierte un archivo de imagen (File) a un Blob con calidad reducida
 * @param {File} file - El archivo de imagen original.
 * @param {number} quality - La calidad de la imagen de salida (0.0 a 1.0).
 * @returns {Promise<File>} - Una promesa que resuelve con un nuevo objeto File de menor tamaño/calidad.
 */


export default function compressImage(file, quality = 0.7) {
  return new Promise((resolve, reject) => {
    // 1. Crear un objeto Image
    const img = new Image();
    
    // Configurar qué hacer una vez que la imagen ha cargado
    img.onload = () => {
      // 2. Crear un elemento canvas
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // 3. Establecer las dimensiones del canvas a las de la imagen original
      canvas.width = img.width;
      canvas.height = img.height;

      // 4. Dibujar la imagen en el canvas
      ctx.drawImage(img, 0, 0, img.width, img.height);

      // 5. Exportar el canvas como un Blob de imagen con calidad reducida
      // 'image/jpeg' o 'image/webp' son buenas opciones para compresión con pérdida.
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Canvas to Blob failed.'));
          return;
        }
        // Crear un nuevo objeto File a partir del Blob, manteniendo el nombre original
        const compressedFile = new File([blob], file.name, {
            type: blob.type,
            lastModified: Date.now(),
        });
        resolve(compressedFile);
      }, 'image/jpeg', quality);
    };

    img.onerror = (error) => {
      reject(new Error("Failed to load image for compression."));
    };

    // Cargar el archivo de imagen en el objeto Image
    img.src = URL.createObjectURL(file);
  });
}